import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './money.less'
import {
  getCurrencySymbol,
  formatMoney,
  isSymbolBeforeValue,
  shouldUseIntlFormat,
} from 'client/griffin'
import CurrencyTextBox from 'components/common/currency_text_box'

class Money extends React.Component {
  static propTypes = {
    currency: PropTypes.string,
    value: PropTypes.number,
    size: PropTypes.oneOf(['big', 'small']),
    removeTrailingZeros: PropTypes.bool,
    editable: PropTypes.bool,
    focusOnMount: PropTypes.number,
    onChange: PropTypes.func,
    atmInput: PropTypes.bool,
    showIntlCurrencyCode: PropTypes.bool,
  }

  static defaultProps = {
    size: 'big',
    removeTrailingZeros: true,
    showIntlCurrencyCode: true,
  }

  render() {
    const currencySymbol = getCurrencySymbol(this.props.currency)
    let valueFormatted
    if (currencySymbol !== '') {
      valueFormatted = formatMoney(this.props.currency, this.props.value, {
        removeTrailingZeros: this.props.removeTrailingZeros,
        showCurrencySymbol: false,
      })
    } else {
      valueFormatted = formatMoney(this.props.currency, this.props.value, {
        removeTrailingZeros: this.props.removeTrailingZeros,
      })
    }

    const symbolBeforeValue = isSymbolBeforeValue(this.props.currency)
    return (
      <div>
        <div styleName={`money-${this.props.size}`}>
          <span styleName={symbolBeforeValue ? 'currency' : 'currency-hidden'}>
            {currencySymbol}
          </span>
          {this.props.editable ? (
            <CurrencyTextBox
              className={styles.value}
              autoResize={true}
              currencyCode={this.props.currency}
              value={this.props.value}
              onChange={this.props.onChange}
              showCurrency={false}
              focusOnMount={this.props.focusOnMount}
              atmInput={this.props.atmInput}
              showIntlCurrencyCode={this.props.showIntlCurrencyCode}
              data-nemo="sendAmount"
              placeholder={formatMoney(this.props.currency, 0, {
                style: 'local',
                removeTrailingZeros: this.props.removeTrailingZeros,
                showCurrencySymbol: false,
              })}
            />
          ) : (
            <span styleName="value">{valueFormatted}</span>
          )}
          <span styleName={symbolBeforeValue ? 'currency-hidden' : 'currency'}>
            {currencySymbol}
          </span>
        </div>
        {this.props.showIntlCurrencyCode &&
          shouldUseIntlFormat(this.props.currency) && (
            <div styleName="currency-code">{this.props.currency}</div>
          )}
      </div>
    )
  }
}

export default cssModules(Money, styles)
